export const commands = {
  SALE: 'sale',
  VOID: 'void',
  LAST_TRANSACTION: 'last_trans',
};
